import { refineFonts } from '@/Theming/refineFonts';

export const styles = {
	collapsedColor: '#757575',
	expandedColor: '#5977EB',
	container: {},
	collapsedContainer: {
		backgroundColor: '#FAFAFA',
		borderRadius: '9px',
		minHeight: '70px',
	},
	expandedContainer: {
		backgroundColor: '#F2F4FD',
		borderRadius: '9px 9px 0px 0px',
		minHeight: '70px',
	},
	collapsibleContainer: {
		borderRadius: '0px 0px 9px 9px',
		border: '1px solid #E0E0E0',
		borderTopWidth: '0px',
		paddingY: '20px',
	},
	emailSentContainer: {
		width: '90%',
	},
	emailSendButton: {
		width: '52px',
		maxHeight: '55px',
		...refineFonts.mediumRegular,
	},
	sendAdditionalEmailButton: { justifyContent: 'flex-start', paddingX: 0 },
};
